import SourcePage from './SourcePage';
import sourcePageReducer from './reducer';

export { sourcePageReducer };
export default SourcePage;
